var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirtable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.50297526.20100591-7.09941044 2.93764625c-.39480037.16338794-.39071029.72415946.00656565.88162754l7.12911731 2.82710645c.62642805.24841855 1.32400201.24841855 1.95032242 0l7.129225-2.82710645c.3971683-.15746808.401366-.7182396.006458-.88162754l-7.0993028-2.93764625c-.6477395-.26800788-1.37534322-.26800788-2.02297514 0",
    fill: "#ffbf00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.1469076 8.39120841v7.06249209c0 .3359247.3387232.565938.6509686.4421592l7.9440119-3.0834899c.1813628-.0718993.300298-.2471269.300298-.4421592v-7.06249207c0-.33592474-.3387232-.56593793-.6509685-.44215918l-7.944012 3.08348988c-.1812551.07189931-.300298.24712699-.300298.44215918",
    fill: "#26b5f8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.29192714 8.75561302-2.35760833 1.13833392-.23937732.11570616-4.97676647 2.3846244c-.31547434.152194-.71813197-.0777115-.71813197-.4281668v-6.62872832c0-.12679249.06501075-.23625595.15219404-.31870335.03638019-.03648782.07760389-.06651762.1204421-.09030467.11893522-.07136113.28856591-.09041229.43279506-.03336644l7.54684367 2.99017147c.38360647.15219408.41374392.68971668.03960922.87043363",
    fill: "#ed3049"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m8.29192714 8.75561302-2.35760833 1.13833392-5.78208172-4.87526791c.03638019-.03648782.07760389-.06651762.1204421-.09030467.11893522-.07136113.28856591-.09041229.43279506-.03336644l7.54684367 2.99017147c.38360647.15219408.41374392.68971668.03960922.87043363",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtable);
export default __webpack_public_path__ + "static/media/airtable.1a0036e1edab38825bc69b6a58c91742.svg";
export { ForwardRef as ReactComponent };